import React from 'react';

interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
  inverted?: boolean;
}

export default function Logo({ className = "h-12 w-auto", style }: LogoProps) {
  return (
    <img
      src="/images/staycoolairco_logo.png"
      alt="StayCool Airconditioning"
      width={360}
      height={117}
      loading="lazy"
      decoding="async"
      className={className}
      style={{
        objectFit: 'contain',
        ...style
      }}
    />
  );
}
